<template>
  <div class="ba-alert">
    <div class="main">
      <!-- Title -->
      <div class="title_bar">
        <div class="left">
          <div class="title">
            告警管理
          </div>
          <div class="tip">
            可在此檢視點位名稱、告警事件、設定推播
          </div>
        </div>
      </div>
      <!-- TAB -->
      <el-tabs
        v-model="activeTabName"
        :before-leave="tabBeforeLeave"
      >
        <el-tab-pane
          label="告警事件列表"
          name="baEvent"
        >
          <Event
            ref="eventListRef"
            :asset-category-data-options="assetCategoryDataOptions"
            @handleClickReport="handleClickReport"
            @handleClickEventDetail="handleClickEventDetail"
            @closeEventReportAndDetailDialog="closeEventReportAndDetailDialog"
          />
        </el-tab-pane>
        <el-tab-pane
          label="告警推播管理"
          name="baManagement"
        >
          <Management
            ref="managementRef"
            :asset-category-data-options="assetCategoryDataOptions"
            @handleClickTagDetail="handleClickTagDetail"
          />
        </el-tab-pane>
        <el-tab-pane
          label="歷史告警紀錄"
          name="baLog"
        >
          <Log
            ref="logRef"
            :asset-category-data-options="assetCategoryDataOptions"
          />
        </el-tab-pane>
        <el-tab-pane
          v-for="item in centerMonitoringLink"
          :key="item.id"
          :label="item.DisplayName"
          :name="centerLinkPrefix + item.Id"
        />
      </el-tabs>
    </div>
    <ReportEvent
      ref="reportEvent"
      @localUpdateEventRow="localUpdateEventRow"
      @localUpdateTagDetail="localUpdateTagDetail"
      @closeEventDetail="closeEventDetail"
    />
    <EventDetail
      ref="eventDetail"
      @handleClickReport="handleClickReport"
    />
    <TagDetail
      ref="deviceDetail"
      @handleClickReport="handleClickReport"
      @handleClickEventDetail="handleClickEventDetail"
    />
  </div>
</template>
<script>
import EventDetail from './components/EventDetail.vue'
import Event from './components/Event.vue'
import ReportEvent from './components/ReportEvent.vue'
import Management from './components/Management.vue'
import TagDetail from './components/TagDetail.vue'
import Log from './components/Log.vue'
import { processAssetCategoryToCascader } from '@/js/utils'
import { apiCenterMonitoring } from '@/api/smartBuildingSystemAPI'

export default {
  components: {
    Event,
    ReportEvent,
    EventDetail,
    Management,
    TagDetail,
    Log
  },
  data () {
    const centerLinkPrefix = 'centerLink_' // tab name有此prefix，則為動態連結tab
    const centerMonitoringLink = []
    // 第一次進來時從路由決定 TAB 為何者
    const activeTabName =
      this.$route.name.toLowerCase().includes('event')
        ? 'baEvent'
        : this.$route.name
    const assetCategoryDataOptions = []
    return {
      activeTabName,
      assetCategoryDataOptions,
      centerMonitoringLink,
      centerLinkPrefix
    }
  },
  async mounted () {
    try {
      this.$refs.eventListRef.initEventList()
      this.$refs.managementRef.initTagList()
      this.$refs.logRef.initLogList()
      // 資產設備類別
      this.getSetAssetCategory()
      const res = await apiCenterMonitoring.GetItems()
      this.centerMonitoringLink = res.data.Items
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    async getSetAssetCategory () {
      // 三個 TAB 都要用，在這裡打一次就好
      try {
        const res = await apiBaAlert.getAssetCategory()
        this.assetCategoryDataOptions = processAssetCategoryToCascader(res.data)
      } catch (error) {
        console.log(error)
      }
    },
    tabBeforeLeave (activeName) {
      // 不切換 TAB，開啟外部連結
      if (activeName.includes(this.centerLinkPrefix)) {
        const id = parseInt(activeName.substring(this.centerLinkPrefix.length))
        const tabItem = this.centerMonitoringLink.find(item => item.Id === id)
        window.open(tabItem.Url)
        return false
      }
      // 切換 TAB 時需更改路由
      this.$router.push({
        name: activeName
      })
      return true
    },
    handleClickReport (id, area) {
      this.$refs.reportEvent.openReportEvent(id, area)
    },
    handleClickEventDetail (id, area) {
      this.$refs.eventDetail.openEventDetail(id, area)
    },
    handleClickTagDetail (row) {
      this.$refs.deviceDetail.openEventDetail(row)
    },
    closeEventReportAndDetailDialog () {
      this.$refs.reportEvent.handleClose(false)
      this.$refs.eventDetail.handleClose(false)
    },
    localUpdateEventRow (updateRowData) {
      this.$refs.eventListRef.localUpdateEventRow(updateRowData)
    },
    localUpdateTagDetail (updateRowData) {
      this.$refs.deviceDetail.localUpdateTagDetail(updateRowData)
    },
    closeEventDetail () {
      this.$refs.eventDetail.handleClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-alert {
  @include mainLayer();
  ::v-deep .emergency {
    color: $dangerColor;
  }
  ::v-deep .warning {
    color: $systemBAOrange;
  }
  ::v-deep pre {
    white-space: pre-wrap; /* Since CSS 2.1 */
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
  }
}
</style>
